import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

const GatewayTable = ({ gatewayList, handleEdit, handleDelete }) => {
  return (
    <div className="gateway-list-card">
      <div className="table-responsive">
        <table className="table gateway-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Provider</th>
              <th>Mode</th>
              <th>API Key</th>
              <th>Secret Key</th>
              <th style={{ textAlign: "center" }}>ACTION</th>
            </tr>
          </thead>
          <tbody>
            {gatewayList.length > 0 ? (
              gatewayList.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.provider}</td>
                  <td>
                    <span className={item.active_mode === "live" ? "gateway-live-badge" : "gateway-demo-badge"}>
                      {item.active_mode ? item.active_mode.toUpperCase() : ""}
                    </span>
                  </td>
                  <td>{item.active_mode === "demo" ? item.demo_api_key : item.live_api_key}</td>
                  <td>{item.active_mode === "demo" ? item.demo_secret_key : item.live_secret_key}</td>
                  <td>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", width: "100%", margin: "0 auto" }}>
                      <button
                        type="button"
                        style={{
                          background: "#2563eb",
                          backgroundColor: "#2563eb",
                          color: "#ffffff",
                          border: "none",
                          borderRadius: "6px",
                          width: "32px",
                          height: "32px",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          padding: 0,
                          flexShrink: 0
                        }}
                        onClick={() => handleEdit(item.id)}
                        title="Edit Configuration"
                      >
                        <FaEdit size={14} color="#ffffff" />
                      </button>
                      <button
                        type="button"
                        style={{
                          background: "#dc2626",
                          backgroundColor: "#dc2626",
                          color: "#ffffff",
                          border: "none",
                          borderRadius: "6px",
                          width: "32px",
                          height: "32px",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          padding: 0,
                          flexShrink: 0
                        }}
                        onClick={() => handleDelete(item.id)}
                        title="Delete Configuration"
                      >
                        <FaTrash size={14} color="#ffffff" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6">No Records Found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GatewayTable;
